<template>
  <v-link
    :to="path || sectionRoute"
    class="o-typography__headline5 o-typography--action u-text-transform-none"
    :class="{
      'c-section__view-all': isTile,
      'o-typography--action-invert': !isTile,
      'c-section__header-additional': !isTile,
    }"
  >
    {{ text }}
    <i class="o-icon o-icon--right"></i>
  </v-link>
</template>
<script>
  import VLink from '../link/index.vue';

  export default {
    components: {
      VLink,
    },
    props: {
      sectionRoute: Object,
      path: String,
      isTile: Boolean,
      label: String,
    },
    computed: {
      text() {
        return this.label || this.$t('glossary.viewAll');
      },
    },
  };
</script>
